import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import Header from './header';
import Nav from './nav';
import Modules from './modules';
import QrCode from './qrCode';
import Cooperation from './cooperation';
import BottomFooter from './bottomFooter';
import Affix from './affix';
import { getTopicPreviewData } from '../../../services/api';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        docData: this.props.content.docData,
    };

    async componentDidMount() {
        if (location.href.includes('cmpp_user')) {
            const id = location.href.split('/special/')[1].split('?')[0];
            const cookieInfo = location.href.split('?')[1];

            const docData = await getTopicPreviewData(id, encodeURIComponent(cookieInfo));

            console.log(docData);

            this.setState({ docData: { ...docData } });
        }
    }

    render() {
        const { docData } = this.state;
        const {
            content: {
                channel,
                qrCode,
                footer,
                topAd,
                slideAd,
                infoAd,
                titleAd1,
                titleAd2,
                titleAd3,
                titleAd4,
                columnAd1,
                columnAd2,
                columnAd3,
                floatAd1,
                floatAd2,
                floatAd3,
                floatAd4,
            },
        } = this.props;

        const footerData = { footer };

        const adArr = {
            slideAd,
            infoAd,
            titleAd1,
            titleAd2,
            titleAd3,
            titleAd4,
            columnAd1,
            columnAd2,
            columnAd3,
        };

        const floatAd = {
            floatAd1,
            floatAd2,
            floatAd3,
            floatAd4,
        };

        return (
            <div className={styles.topic}>
                <Header content={channel} />
                <div className={styles.bannerImg}>
                    {docData.pcBannerImg ? (
                        <React.Fragment>
                            <img src={docData.pcBannerImg} />
                            <div className={styles.mask} />
                        </React.Fragment>
                    ) : (
                        ''
                    )}
                    <div className={docData.pcBannerImg ? styles.banner_title : styles.noBanner_title}>
                        <h2>{docData.title}</h2>
                        <p>{docData && docData.introDisplay === 1 ? docData.introduction : ''}</p>
                    </div>
                </div>
                <div className={styles.layout}>
                    <Nav />
                    <div className={styles.box_l}>
                        <Ad content={topAd} />
                        {docData.modules && <Modules docData={docData} content={docData.modules} ad={adArr} />}
                        <Cooperation content={docData.ad} />
                    </div>
                    <div className={styles.box_r}>
                        <Chip type="struct" id="170062" title="PC专题页二维码" groupName="正文侧栏" content={qrCode}>
                            <QrCode />
                        </Chip>
                    </div>
                    <BottomFooter content={footerData} />
                </div>
                <Affix ad={floatAd} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
